/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ActionEnum {
    access_analytics = 'access_analytics',
    access_governance = 'access_governance',
    account = 'account',
    activate = 'activate',
    activity_analytics = 'activity_analytics',
    admin_dashboard = 'admin_dashboard',
    admin_reports = 'admin_reports',
    approval = 'approval',
    approve = 'approve',
    assessment_reports = 'assessment_reports',
    automation_analytics = 'automation_analytics',
    availability_reports = 'availability_reports',
    backup_analytics = 'backup_analytics',
    cancel = 'cancel',
    clone = 'clone',
    cloud_inventory_reports = 'cloud_inventory_reports',
    cloud_service_analytics = 'cloud_service_analytics',
    compliance_analytics = 'compliance_analytics',
    compliance_reports = 'compliance_reports',
    contribute = 'contribute',
    cost_analytics = 'cost_analytics',
    cost_governance = 'cost_governance',
    cost_recommendations = 'cost_recommendations',
    cost_reports = 'cost_reports',
    cost_usage_reports = 'cost_usage_reports',
    create = 'create',
    delegate = 'delegate',
    delete = 'delete',
    detail = 'detail',
    execute = 'execute',
    extend_trial = 'extend_trial',
    generate_posture = 'generate_posture',
    global = 'global',
    inventory_analytics = 'inventory_analytics',
    inventory_report = 'inventory_report',
    inventory_reports = 'inventory_reports',
    manage = 'manage',
    manage_acl = 'manage_acl',
    manage_owner = 'manage_owner',
    manage_children = 'manage_children',
    manager_dashboard = 'manager_dashboard',
    monitoring_analytics = 'monitoring_analytics',
    monitoring_reports = 'monitoring_reports',
    operations_governance = 'operations_governance',
    partner_cost_reports = 'partner_cost_reports',
    patch_analytics = 'patch_analytics',
    patch_compliance_report = 'patch_compliance_report',
    patch_management = 'patch_management',
    policy_reports = 'policy_reports',
    Private = 'private',
    publish = 'publish',
    read = 'read',
    read_children = 'read_children',
    reject = 'reject',
    remediate = 'remediate',
    resolve = 'resolve',
    resource_governance = 'resource_governance',
    revoke = 'revoke',
    security_analytics = 'security_analytics',
    security_governance = 'security_governance',
    security_reports = 'security_reports',
    share = 'share',
    show_menu = 'show_menu',
    status = 'status',
    system_reports = 'system_reports',
    tenant = 'tenant',
    terminate_trial = 'terminate_trial',
    threat_analytics = 'threat_analytics',
    update = 'update',
    utilization_reports = 'utilization_reports',
    view_quota = 'view_quota',
    vulnerability_analytics = 'vulnerability_analytics'
}
